export const SET_SHOP_FILTERS = 'SET_SHOP_FILTERS';
export const RESET_SHOP_FILTERS = 'RESET_SHOP_FILTERS';
export const SET_SHOP_SORTING = 'SET_SHOP_SORTING';

export const FETCH_SHOP_PRODUCTS = 'FETCH_SHOP_PRODUCTS';
export const FETCH_SHOP_PRODUCTS_SUCCESS = 'FETCH_SHOP_PRODUCTS_SUCCESS';
export const FETCH_SHOP_PRODUCTS_ERROR = 'FETCH_SHOP_PRODUCTS_ERROR';

export const CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS = 'CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS';
export const CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_SUCCESS =
  'CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_SUCCESS';
export const CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_ERROR =
  'CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS_ERROR';

export const FETCH_SHOP_HISTORY = 'FETCH_SHOP_HISTORY';
export const FETCH_SHOP_HISTORY_SUCCESS = 'FETCH_SHOP_HISTORY_SUCCESS';
export const FETCH_SHOP_HISTORY_ERROR = 'FETCH_SHOP_HISTORY_ERROR';

export const ADD_SHOP_PRODUCTS_TO_BASKET = 'ADD_SHOP_PRODUCTS_TO_BASKET';
export const ADD_SHOP_PRODUCTS_TO_BASKET_SUCCESS = 'ADD_SHOP_PRODUCTS_TO_BASKET_SUCCESS';
export const ADD_SHOP_PRODUCTS_TO_BASKET_ERROR = 'ADD_SHOP_PRODUCTS_TO_BASKET_ERROR';

export const REMOVE_SHOP_PRODUCTS_FROM_BASKET = 'REMOVE_SHOP_PRODUCTS_FROM_BASKET';
export const REMOVE_SHOP_PRODUCTS_FROM_BASKET_SUCCESS = 'REMOVE_SHOP_PRODUCTS_FROM_BASKET_SUCCESS';
export const REMOVE_SHOP_PRODUCTS_FROM_BASKET_ERROR = 'REMOVE_SHOP_PRODUCTS_FROM_BASKET_ERROR';

export const SET_SHOP_ACIVE_VIEW = 'SET_SHOP_ACIVE_VIEW';

export const FETCH_SHOP_PRODUCT_PROPERTIES = 'FETCH_SHOP_PRODUCT_PROPERTIES';
export const FETCH_SHOP_PRODUCT_PROPERTIES_SUCCESS = 'FETCH_SHOP_PRODUCT_PROPERTIES_SUCCESS';
export const FETCH_SHOP_PRODUCT_PROPERTIES_ERROR = 'FETCH_SHOP_PRODUCT_PROPERTIES_ERROR';

export const START_SHOP_PRODUCT_FREE_TRIAL = 'START_SHOP_PRODUCT_FREE_TRIAL';
export const START_SHOP_PRODUCT_FREE_TRIAL_SUCCESS = 'START_SHOP_PRODUCT_FREE_TRIAL_SUCCESS';
export const START_SHOP_PRODUCT_FREE_TRIAL_ERROR = 'START_SHOP_PRODUCT_FREE_TRIAL_ERROR';

export const START_SHOP_PRODUCT_FREE_SUBSCRIPTION = 'START_SHOP_PRODUCT_FREE_SUBSCRIPTION';
export const START_SHOP_PRODUCT_FREE_SUBSCRIPTION_SUCCESS =
  'START_SHOP_PRODUCT_FREE_SUBSCRIPTION_SUCCESS';
export const START_SHOP_PRODUCT_FREE_SUBSCRIPTION_ERROR = 'START_SHOP_PRODUCT_FREE_TRIAL_ERROR';

export const FETCH_SHOP_PERMISSIONS = 'FETCH_SHOP_PERMISSIONS';
export const FETCH_SHOP_PERMISSIONS_SUCCESS = 'FETCH_SHOP_PERMISSIONS_SUCCESS';
export const FETCH_SHOP_PERMISSIONS_ERROR = 'FETCH_SHOP_PERMISSIONS_ERROR';

export const setShopFiltersAction = ({ filters }) => ({
  type: SET_SHOP_FILTERS,
  payload: {
    filters,
  },
});

export const resetShopFiltersAction = () => ({
  type: RESET_SHOP_FILTERS,
});

export const setShopSortingAction = ({ sortBy }) => ({
  type: SET_SHOP_SORTING,
  payload: {
    sortBy,
  },
});

export const fetchShopProductsAction = () => ({
  type: FETCH_SHOP_PRODUCTS,
});

export const changeShopProductsFavoriteStatusAction = ({ ids, isFavorite }) => ({
  type: CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS,
  payload: { ids, isFavorite },
});

export const fetchShopHistoryAction = () => ({
  type: FETCH_SHOP_HISTORY,
});

export const addShopProductsToBasketAction = ({ ids }) => ({
  type: ADD_SHOP_PRODUCTS_TO_BASKET,
  payload: { ids },
});

export const removeShopProductsFromBasketAction = ({ ids }) => ({
  type: REMOVE_SHOP_PRODUCTS_FROM_BASKET,
  payload: { ids },
});

export const setShopActiveViewAction = ({ view }) => ({
  type: SET_SHOP_ACIVE_VIEW,
  payload: { view },
});

export const fetchShopProductPropertiesAction = () => ({
  type: FETCH_SHOP_PRODUCT_PROPERTIES,
});

export const startShopProductFreeTrialAction = ({ id }) => ({
  type: START_SHOP_PRODUCT_FREE_TRIAL,
  payload: { id },
});

export const startShopProductFreeSubscriptionAction = ({ id }) => ({
  type: START_SHOP_PRODUCT_FREE_SUBSCRIPTION,
  payload: { id },
});

export const fetchShopPermissionsAction = () => ({
  type: FETCH_SHOP_PERMISSIONS,
});
